export const playCircle = {
	className: 'icon-play-circle',
	viewBox: '0 0 200.42001 194.71801',
}
